import React, { useEffect } from "react";

import AllRoutes from "./routes/Routes";
import { configureFakeBackend } from "./helpers";
import OfflineBanner from "./components/OfflineBanner";
import { ToastContainer } from "./components/Toast";
import { purgeExpiredCache } from "./utils/offlineDB";

// Theme
import "./assets/scss/Theme.scss";

configureFakeBackend();

const App = () => {
  // Silently purge stale IndexedDB cache entries once per session
  useEffect(() => {
    purgeExpiredCache().catch(() => {/* silent — non-critical */});
  }, []);

  return (
    <React.Fragment>
      {/* Offline / sync status bar — auto-hides when online and queue is empty */}
      <OfflineBanner />
      <AllRoutes />
      {/* Toast notifications — fixed top-right, portal-like, mounted once */}
      <ToastContainer />
    </React.Fragment>
  );
};

export default App;
